import { render, staticRenderFns } from "./EditViewTermReportsSubjectRecords.vue?vue&type=template&id=f49afe8a"
import script from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsSubjectRecords.vue?vue&type=style&index=0&id=f49afe8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports